module.exports = __webpack_public_path__ + "static/media/edit_pencil.3f5c002f.svg";